var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"terms"},_vm._l((_vm.articles),function(article,idx){return _c('article',{key:`terms-${idx}`,staticClass:"terms__article"},[(!!article.title)?_c('h3',{staticClass:"terms__title"},[_vm._v(_vm._s(article.title))]):_vm._e(),_c('div',{staticClass:"terms__text",domProps:{"innerHTML":_vm._s(article.text)}})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }